import React, { useCallback, useMemo } from 'react';
import FieldSearch from 'components/molecules/field-search';
import forms from 'constants/forms';
import { useAminPanelSearchPatients } from 'infrastructure/hooks/patient/use-admin-panel-search-patient';
import { debounce } from 'lodash';

import type { ISmsCampaignsProgressFilters } from 'infrastructure/interfaces';

export const fieldOptions = forms.smsCampaignsPatientFilter.map((opt) => ({
  value: opt.id,
  label: opt.label,
  placeholder: opt.placeholder,
}));

interface IProps {
  data: ISmsCampaignsProgressFilters;
  updateFilter: (data: ISmsCampaignsProgressFilters) => void;
}

const SmsCampaignsFieldSearchFilter: React.FC<IProps> = ({
  data,
  updateFilter,
}) => {
  const { searchPatients, searchPatientsLoading, patients } =
    useAminPanelSearchPatients();

  const debounceSearchPatients = useCallback(debounce(searchPatients, 800), []);

  const patientOptions =
    patients?.data ??
    (data.patientLabel && data.patientGuid
      ? [{ label: data.patientLabel, value: data.patientGuid }]
      : []);

  const placeholder = useMemo(
    () => fieldOptions.find((o) => o.value === data.patientKey)?.placeholder,
    [data.patientKey],
  );

  return (
    <FieldSearch
      fields={{
        options: fieldOptions,
        defaultValue: fieldOptions[0],
        value: data.patientKey,
        onChange: (v) => {
          updateFilter({ patientKey: v });
        },
      }}
      search={{
        value: data.patientGuid,
        isLoading: searchPatientsLoading,
        options: patientOptions,
        placeholder,
        onChange: (v) =>
          debounceSearchPatients({
            searchValue: v,
            searchKey: data.patientKey!,
          }),
        onSelect: (v, option) => {
          updateFilter({
            page: undefined,
            patientGuid: v,
            patientLabel: option.label as string,
          });
        },
        onClear: () => {
          updateFilter({
            page: undefined,
            patientGuid: undefined,
            patientLabel: undefined,
          });
        },
      }}
    />
  );
};

export default SmsCampaignsFieldSearchFilter;
